import { render } from "./DSidebar.vue?vue&type=template&id=14063f4f"
import script from "./DSidebar.vue?vue&type=script&lang=js"
export * from "./DSidebar.vue?vue&type=script&lang=js"

import "./DSidebar.vue?vue&type=style&index=0&id=14063f4f&lang=css"

import exportComponent from "F:\\weblocal\\taxe.local\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__